module.exports = __webpack_public_path__ + "assets/img/20_160_big.c194bed3.jpg";